<div class="container-fluid" [@fadeInAnimation]>
  <div class="row">
    <div class="col-lg-2"></div>
    <div class="col-lg-8">
      <div class="jumbotron" style="background-color: #f3f3f3 !important">
        <div class="garanti-xl-logo text-center">
          <img [src]="isBorgenarMode ? 'assets/img/borgenarsportal-logo.png' : 'assets/img/garanti-portal-logo.png'" />
        </div>
        <div class="frontpage-text lead">
          <span [innerHTML]="(isBorgenarMode ? borgenarTextKey : textKey) | translate | safehtml"></span>
        </div>
      </div>
    </div>
  </div>
</div>
